<!-- IntroductionComponent.vue -->
<template>
  <v-form
    v-model="$storeUniversite.validIntroduction"
    ref="formValidation"
    lazy-validation
  >
    <div class="stepper-container">
      <!-- Première ligne -->
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="$storeUniversite.inscription.Prenom"
            :label="$storeUniversite.label.Prenom"
            outlined
            :rules="[$rules.obligatoire(), $rules.latin()]"
            :disabled="$storeUniversite.lectureSeule"
            dense
            class="asterisk"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="$storeUniversite.inscription.Nom"
            :label="$storeUniversite.label.Nom"
            outlined
            :rules="[$rules.obligatoire(), $rules.latin()]"
            :disabled="$storeUniversite.lectureSeule"
            dense
            class="asterisk"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
          :disabled="$storeUniversite.lectureSeule"
            v-model="$storeUniversite.inscription.Email"
            :label="$storeUniversite.label.Email"
            outlined
            :rules="[$rules.obligatoire(), $rules.email(), $rules.latin()]"
            dense
            class="asterisk"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
          :disabled="$storeUniversite.lectureSeule"
            v-model="$storeUniversite.inscription.ConfirmationEmail"
            :label="$storeUniversite.label.ConfirmationEmail"
            outlined
            :rules="[
                  $rules.EqualMail(
                    $storeUniversite.inscription.Email
                  ),
                ]"
            dense
            @paste.prevent
                @copy.prevent
            class="asterisk"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
          :disabled="$storeUniversite.lectureSeule"
            v-model="$storeUniversite.inscription.Tel"
            :label="$storeUniversite.label.TelPortable"
            :rules="[$rules.obligatoire(), $rules.telephone()]"
            outlined
            dense
            class="asterisk"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-autocomplete
          :disabled="$storeUniversite.lectureSeule"
            :rules="[$rules.obligatoire(), $rules.latin()]"
            v-model="$storeUniversite.inscription.PaysDeResidence"
            :label="$storeUniversite.label.PaysResidence"
            :item-text="$storeUniversite.itemLang"
            item-value="id"
            :items="$storeCatalogue.Pays"
            outlined
            dense
            class="asterisk"
          ></v-autocomplete>
        </v-col>
      </v-row>
    <v-row>
        <v-col cols="12" md="6">
          <v-text-field
          :disabled="$storeUniversite.lectureSeule"
            :rules="[$rules.obligatoire(), $rules.cni()]"
            v-model="$storeUniversite.inscription.NumCniPasseport"
            :label="
              $storeUniversite.inscription.PaysDeResidence ===
              this.$storeCatalogue.DataId.Maroc
                ? $storeUniversite.label.CIN
                : $storeUniversite.label.NumPassport
            "
            outlined
            dense
            class="asterisk"
          ></v-text-field>
        </v-col>
          <v-col cols="12" md="6">
          <v-text-field
          :disabled="$storeUniversite.lectureSeule"
            v-model="$storeUniversite.inscription.ConfirmationNumCniPasseport"
            :label="$storeUniversite.inscription.PaysDeResidence ===
              this.$storeCatalogue.DataId.Maroc
                ? $storeUniversite.label.ConfirmationCIN
                : $storeUniversite.label.ConfirmationNumPassport"
            outlined
            :rules="[
                  $rules.EqualNumCni(
                    $storeUniversite.inscription.NumCniPasseport
                  ),
                ]"
            dense
            @paste.prevent
                @copy.prevent
            class="asterisk"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" md="6">
          <v-autocomplete 
            dense
            :disabled="$storeUniversite.lectureSeule || $storeUniversite.ChoixCycle.length == 0" 
            v-model="$storeUniversite.inscription.ChoixCycle" 
            :items="$storeUniversite.ChoixCycle"
            :item-text="$storeUniversite.itemLang" 
            item-value="id" 
            :label="$storeUniversite.label.ChoixCycle" 
            outlined
            :rules="[$rules.obligatoire(), $rules.latin()]"
            @change="ChoixCycleChange"
            class="asterisk"></v-autocomplete>
            <div v-if="$storeUniversite.ChoixCycle.length == 0" class="v-messages theme--light error--text" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message message-transition-enter-to">{{$storeUniversite.label.MessageCondidaturesClotures}}</div></div></div>
        </v-col>
        <v-col cols="6" md="6">
          <v-autocomplete
            :disabled="$storeUniversite.lectureSeule || $storeUniversite.NiveauEtude.length == 0"
            :rules="[$rules.arrayObligatoire()]"
            v-model="$storeUniversite.inscription.NiveauDEtude"
            :items="$storeUniversite.NiveauEtude"
            :item-text="$storeUniversite.itemLang"
            item-value="id"
            :label="$storeUniversite.label.DiplomePostule"
            dense
            outlined
            multiple
            class="asterisk"
          ></v-autocomplete>
          <div v-if="$storeUniversite.NiveauEtude.length == 0" class="v-messages theme--light error--text" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message message-transition-enter-to">{{$storeUniversite.label.MessageCondidaturesClotures}}</div></div></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-autocomplete
           :disabled="$storeUniversite.lectureSeule"
            v-model="$storeUniversite.inscription.ConnaissanceUm6p"
            :label="$storeUniversite.label.ConnaissanceFirsi"
            :item-text="$storeUniversite.itemLang"
            item-value="id"
            :items="$storeCatalogue.ConnaissanceFirsi"
            :rules="[$rules.obligatoire(), $rules.latin()]"
            outlined
            dense
            class="asterisk"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <p>{{ $storeUniversite.label.TexteAvantCharte }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-checkbox dense :disabled="$storeUniversite.lectureSeule" 
          :rules="[$rules.checkboxObligatoire()]" 
          v-model="$storeUniversite.inscription.RGPD">
            <template #label>
              <div @click.stop="handleLinkClick"
                v-html="$storeUniversite.label.LabelCaseCocher"
              ></div> </template
          ></v-checkbox>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      //réafecter l'objet global
      $storeUniversite: this.$storeUniversite,
      labelCiPassePort: this.$storeUniversite.label.CIN,
    };
  },
  methods: {
    ChoixCycleChange() {
      if (this.$storeUniversite.inscription.ChoixCycle == this.$storeCatalogue.DataId.CyclePostBac) {
        this.$storeUniversite.inscription.NiveauDEtude = [this.$storeCatalogue.DataId.PostBac];
        this.$storeUniversite.NiveauEtude = this.$storeUniversite.NiveauEtudeFixe.filter(item=> item.id == this.$storeCatalogue.DataId.PostBac);
      }
      else if (this.$storeUniversite.inscription.ChoixCycle == this.$storeCatalogue.DataId.CycleMasterInge) {
        this.$storeUniversite.NiveauEtude = this.$storeUniversite.NiveauEtudeFixe
                                            .filter(item=> item.id == this.$storeCatalogue.DataId.ProgrammeIngenieur 
                                            || item.id == this.$storeCatalogue.DataId.Master
                                            || item.id == this.$storeCatalogue.DataId.ProgrammeParallele
                                            || item.id == this.$storeCatalogue.DataId.ProgrammeParalleleBac1);
        this.$storeUniversite.inscription.NiveauDEtude = this.$storeUniversite.inscription.NiveauDEtude.filter(item=> item != this.$storeCatalogue.DataId.PostBac);
      }
    },
    valider() {
      this.$refs.formValidation.validate();
    },
    
    handleLinkClick() {
      // Ajoutez ici la logique que vous souhaitez exécuter lors du clic sur le lien
      //window.open("https://um6p.ma/fr/conditions-generales-dutilisation", "_blank");
    },
  },
  mounted() {
    this.$refs.formValidation.resetValidation();
  },
};
</script>

<style scoped>
/* Ajoutez vos styles personnalisés ici */
</style>
